import { useParams, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { fetchStudies, updateStudy } from '../services/studyService';
import { isClosedStudy } from '../services/enrollmentRules';
import { UI_REVAMP_ENABLED } from '../config/featureFlags';
import LeadCrcInput from './study/LeadCrcInput';

const EditStudyPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState(null);
  const [loadedStudy, setLoadedStudy] = useState(null);

  useEffect(() => {
    const loadStudy = async () => {
      const data = await fetchStudies();
      const found = data.find((s) => s.id === id);
      setFormData(found);
      setLoadedStudy(found);
    };
    loadStudy();
  }, [id]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    await updateStudy(id, formData);
    // Closing a study here hands off to the study page, which offers its
    // enrolled patients back to referrals.
    const justClosed = !isClosedStudy(loadedStudy) && isClosedStudy(formData);
    navigate(`/study/${id}`, justClosed ? { state: { justClosed: true } } : undefined);
  };

  if (!formData) return <p className="p-6">Loading...</p>;

  return (
    <div className="p-6 max-w-4xl mx-auto bg-white rounded shadow">
      <h2 className="text-2xl font-bold mb-4">Edit Study</h2>

      {Object.keys(formData).filter(k => k !== 'id').map((key) =>
        // UI revamp: Lead CRC is picked from the roster here too, like Add / Edit
        // Study (still stored as a string; an old typed name is kept and labelled).
        UI_REVAMP_ENABLED && key === 'LEAD_CRC' ? (
          <div className="mb-3" key={key}>
            <LeadCrcInput
              label={key}
              value={formData.LEAD_CRC || ''}
              onChange={(name) => setFormData((prev) => ({ ...prev, LEAD_CRC: name }))}
            />
          </div>
        ) : (
        <div className="mb-3" key={key}>
          <label className="block text-sm font-medium mb-1">{key}</label>
          <input
            type="text"
            name={key}
            value={formData[key] || ''}
            onChange={handleChange}
            className="w-full border border-gray-300 rounded p-2"
          />
        </div>
        )
      )}

      <div className="mt-6 flex gap-4">
        <button onClick={handleSubmit} className="px-4 py-2 bg-blue-600 text-white rounded">
          Save
        </button>
        <button onClick={() => navigate(`/study/${id}`)} className="px-4 py-2 bg-gray-400 text-white rounded">
          Cancel
        </button>
      </div>
    </div>
  );
};

export default EditStudyPage;
